import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import './App.scss';
import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import Loading from './components/Loading/Loading';
import LoginProtector from './protector/LoginProtector';

import Layout from './pages/Layout';
import Dashlayout from './pages/dashboard/DashLayout/Dashlayout';
import AuthLayout from './pages/Auth/AuthLayout';

import axios from 'axios';
import { BaseUrl } from './API/ApiHandle';
import { useCookies } from 'react-cookie';
import { ChartContext } from './Context/Charts';
import ShareLayout from './pages/Share/ShareLayout';
import ChangeEmailLayout from './pages/ChangeEmail.Layout';
import NotFound from './pages/NotFound/NotFound';
import AlertPage from './pages/AlertPage/AlertPage';
import RoleProtector from './protector/Roleprotector';
import { jwtDecode } from 'jwt-decode';
import { AuthContext } from './Context/Authcontext';
import ViewerReports from './pages/Home/Viewerreports/ViewerReports';
import UnderDevelopmentPage from './pages/UnderDevelopment';

// Viewer 
const ViewerHome = lazy(() => import("./pages/Home/ViewerHome/ViewerHome"));
const ReportDetails = lazy(() => import("./pages/Home/ViewerReportDetails/ReportDetails"));

// analyst 
const Home = lazy(() => import("./pages/Home/Home"));
const SignUp = lazy(() => import("./pages/Auth/SignUp/SignUp"));
const Visualize = lazy(() => import("./pages/Visualize/Visualize"));
const Dashboard = lazy(() => import("./pages/dashboard/Admin/DashboardAdmin"));
const Analysts = lazy(() => import("./pages/dashboard/Analysts/DashboardAnalysts"));
const Veiwer = lazy(() => import("./pages/dashboard/Viewer/DashboarViewer"));

const Support = lazy(() => import("./pages/Support/Support"));
const Tables = lazy(() => import("./pages/Tables/Tables"));
const Share = lazy(() => import("./pages/Share/Share"));
const Aboutus = lazy(() => import("./pages/Aboutus/Aboutus"));

const Login = lazy(() => import("./pages/Auth/Login/Login"));
const Forget = lazy(() => import("./pages/Auth/ForgetPassword/ForgetPassword"));
const Change = lazy(() => import("./pages/Auth/ChangePassword/ChangePassword"));
const ChangeEmail = lazy(() => import('./pages/Auth/ChangeEmail/ChangeEmail'));

const Profile = lazy(() => import("./pages/Profile/Profile"));

function App() {
  const [Cookies,] = useCookies(['rqm']);
  const { setConfirmed } = useContext(ChartContext);
  const { setUserRole, userRole, setuserId } = useContext(AuthContext);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    const fetchUserConfirmation = async () => {
      if (!Cookies.rqm) {
        setIsAuthLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(Cookies.rqm);
        const role = decoded.role;
        const id = decoded.id;

        console.log("appjs", role);
        setuserId(id);
        setUserRole(role);

        const { data } = await axios.get(`${BaseUrl}/check_confirmation`, {
          headers: {
            Authorization: `Bearer ${Cookies.rqm}`
          }
        });

        console.log(data);
        setConfirmed(data?.confirmed);
      } catch (error) {
        console.error("Error fetching user role:", error);
      } finally {
        setIsAuthLoading(false);
      }
    };

    fetchUserConfirmation();
  }, [Cookies.rqm, setConfirmed, setUserRole, setuserId]);

  const SECRET_PATH = "Y8rpL2vKw9!XsZ"; // 👈 You can change this anytime
  const currentPath = window.location.pathname;
  const isDevAccess = currentPath.startsWith(`/${SECRET_PATH}`);

  const router = createBrowserRouter([
    {
      path: ``,
      children: [

        {
          path: "",
          element: isAuthLoading ? (
            <Loading />
          ) : (
            userRole === "admin" ? <Navigate to={`${SECRET_PATH}/admin`} replace /> :
              userRole === "analyst" ? <Navigate to={`${SECRET_PATH}/analyst`} replace /> :
                <Layout role={"viewer"} />
          ),
          children: userRole === "admin" || userRole === "analyst" ? [] : [
            {
              index: true,
              element: (
                <Suspense fallback={<Loading />}><ViewerHome /></Suspense>
              )
            },
            {
              path: 'reportdetails/:report_id',
              element: <Suspense fallback={<Loading />}><ReportDetails /></Suspense>
            },
            {
              path: 'reports',
              element: <Suspense fallback={<Loading />}><ViewerReports /></Suspense>
            },
            {
              path: 'Support',
              element: <Suspense fallback={<Loading />}><Support /></Suspense>
            },
            {
              path: 'aboutus',
              element: <Suspense fallback={<Loading />}><Aboutus /></Suspense>
            },
            {
              path: "profile",
              element: (
                <Suspense fallback={<Loading />}>
                  <LoginProtector>
                    <RoleProtector requiredRole="viewer">
                      <Profile />
                    </RoleProtector>
                  </LoginProtector>
                </Suspense>
              )
            }
          ],
        },

        {
          path: "analyst",
          element: (
            <LoginProtector>
              <RoleProtector requiredRole="analyst">
                <Layout role="analyst" />
              </RoleProtector>
            </LoginProtector>
          ),
          children: [
            { index: true, element: <Suspense fallback={<Loading />}><Home /></Suspense> },
            { path: 'Tables/:id', element: <Suspense fallback={<Loading />}><Tables /></Suspense> },
            { path: 'Visualize/:TableId', element: <Suspense fallback={<Loading />}><Visualize /></Suspense> },
            { path: 'Support', element: <Suspense fallback={<Loading />}><Support /></Suspense> },
            { path: "profile", element: <Suspense fallback={<Loading />}><Profile /></Suspense> },
            { path: 'aboutus', element: <Suspense fallback={<Loading />}><Aboutus Analyst /></Suspense> },
          ],
        },

        {
          path: "admin",
          element: (
            <LoginProtector>
              <RoleProtector requiredRole="admin">
                <Layout role="admin" />
              </RoleProtector>
            </LoginProtector>
          ),
          children: [
            { index: true, element: <Suspense fallback={<Loading />}><Home /></Suspense> },
            { path: 'Tables/:id', element: <Suspense fallback={<Loading />}><Tables /></Suspense> },
            { path: 'Visualize/:TableId', element: <Suspense fallback={<Loading />}><Visualize /></Suspense> },
            { path: 'Support', element: <Suspense fallback={<Loading />}><Support /></Suspense> },
            { path: "profile", element: <Suspense fallback={<Loading />}><Profile /></Suspense> },
            { path: 'aboutus', element: <Suspense fallback={<Loading />}><Aboutus /></Suspense> },
          ],
        },

        {
          path: "dashboard",
          element: (
            <LoginProtector>
              <RoleProtector requiredRole="admin">
                <Dashlayout />
              </RoleProtector>
            </LoginProtector>
          ),
          children: [
            { index: true, element: <Suspense fallback={<Loading />}><Dashboard /></Suspense> },
            { path: 'Analysts', element: <Suspense fallback={<Loading />}><Analysts /></Suspense> },
            { path: 'Veiwer', element: <Suspense fallback={<Loading />}><Veiwer /></Suspense> },
          ],
        },

        {
          path: "Auth",
          element: <AuthLayout />,
          children: [
            { path: "Login", element: <Suspense fallback={<Loading />}><Login /></Suspense> },
            { path: "SignUp", element: <Suspense fallback={<Loading />}><SignUp /></Suspense> },
            { path: "Forget", element: <Suspense fallback={<Loading />}><Forget /></Suspense> },
            { path: "Reset/:rqm", element: <Suspense fallback={<Loading />}><Change /></Suspense> },
          ]
        },

        {
          path: "Charts/:file_id",
          element: <Suspense fallback={<Loading />}><Share /></Suspense>
        },

        {
          path: "changeEmail/:rqm",
          element: <Suspense fallback={<Loading />}><ChangeEmail /></Suspense>
        },

        {
          path: "*",
          element: <NotFound />,
        },

        {
          path: "Alert/:errorMessage/:userId",
          element: <AlertPage />
        }

      ]
    }],
    {
      basename: '/Y8rpL2vKw9!XsZ', // ✅ set it here
    });


  if (isAuthLoading) {
    return <Loading />;
  }

  console.clear();

  if (!isDevAccess) {
    return <UnderDevelopmentPage />;
  }


  return <RouterProvider router={router} />;
}

export default App;